import Vue from "vue";
import VueRouter from "vue-router";
import AuditList from "../modules/audit/views/AuditList";
import AuditListItem from "../modules/audit/views/AuditListItem";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "AuditList",
    component: AuditList,
  },
  {
    path: "/audit-list-item/:id",
    name: "AuditListItem",
    component: AuditListItem,
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
